import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "./Layout";
import config from "../config";
import Searchicon from "../components/searchicon";
import HomeIcon from "../assets/icons/home_icon";
import { Pagination } from "@mui/material";
import { toast } from "react-toastify";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import enGB from "date-fns/locale/en-GB"; // British format

registerLocale("en-GB", enGB);

const CustomerPage = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchName, setSearchName] = useState("");
  const [searchMobile, setSearchMobile] = useState("");
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const [currentDate, setCurrentDate] = useState("");
  const [oneMonthBefore, setOneMonthBefore] = useState("");
  const [selectedDateType, setSelectedDateType] = useState("all");
  const [customerType, setCustomerType] = useState("");


  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const navigate = useNavigate();

  const fetchCustomers = async (query = {}) => {
    try {
      const fullQuery = {
        ...query,
        page,
        limit: 10,
      };
      const queryParams = new URLSearchParams(fullQuery).toString();

      const response = await fetch(
        `${config.BASE_URL}/api/v1/list?${queryParams}`
      );
      if (!response.ok) throw new Error("Failed to fetch customers");

      const { data, total, pages } = await response.json();
      setCustomers(data || []);
      setTotalPages(pages || 1);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   const today = new Date();
  //   const oneMonthAgo = new Date(new Date().setMonth(today.getMonth() - 1));

  //   setCurrentDate(today.toISOString().split("T")[0]);
  //   setOneMonthBefore(oneMonthAgo.toISOString().split("T")[0]);
  // }, []);

 const handleSearch = (field, value) => {
  // 1. Update the state immediately so the UI shows the pasted text
  if (field === "name") setSearchName(value);
  if (field === "mobile") setSearchMobile(value);

  // 2. Clear previous timer
  if (debounceTimeout) clearTimeout(debounceTimeout);

  // 3. Set new timer
  const newTimeout = setTimeout(() => {
    const query = {};

    // Use the 'value' parameter directly for the field being changed
    // Use the existing state for the other field
    if (field === "name") {
      if (value) query.customer_name = value;
      if (searchMobile) query.mobile = searchMobile;
    } else if (field === "mobile") {
      if (searchName) query.customer_name = searchName;
      if (value) query.mobile = value;
    }

    fetchCustomers(query);
  }, 300);

  setDebounceTimeout(newTimeout);
};
  const handleDateChange = (e, type) => {
    const selectedDate = e.target.value;
    if (type === "start") {
      setOneMonthBefore(selectedDate);
    } else if (type === "end") {
      setCurrentDate(selectedDate);
    }
  };

  useEffect(() => {
  const query = {};

  if (searchName) query.customer_name = searchName;
  if (searchMobile) query.mobile = searchMobile;
  if (customerType) query.customer_type = customerType;
 

  fetchCustomers(query);
}, [page, searchName, searchMobile, customerType]);

  const handleRowClick = (customerId) => {
    navigate(`/customer-detail/${customerId}`);
  };

  const parseDate = (dateStr) => {
    const parsed = new Date(dateStr);
    return isNaN(parsed) ? null : parsed;
  };

  const [isLoading, setIsLoading] = useState(false);

  const handleExportCSV = async () => {
    setIsLoading(true);
    try {
      const params = new URLSearchParams({
        start_date: oneMonthBefore,
        end_date: currentDate,
        date_type: selectedDateType.toLowerCase().replace(" ", "_"),
        customer_type: customerType,
        type :"customer"
      }).toString();
      
      const response = await fetch(
        `${config.BASE_URL}/api/v1/export-csv?${params}`
      );
      // console.log(response);
     if (!response.ok) {
  const errorData = await response.json();
  throw new Error(errorData.message || "No customers found for the selected date range");
}

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "customers.csv");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
    console.error("Error exporting CSV:", error);
    toast.error("No customer found for the selected filters");

    } finally {
      setIsLoading(false);
    }
  };

  const handleDateTypeChange = (e) => {
    setSelectedDateType(e.target.value);
     const today = new Date();
    const oneMonthAgo = new Date(new Date().setMonth(today.getMonth() - 1));

     setCurrentDate(today.toISOString().split("T")[0]);
     setOneMonthBefore(oneMonthAgo.toISOString().split("T")[0]);
  };

  return (
    <Layout>
      <div className="customer-page">
        <header className="header">
          <h1>CUSTOMERS</h1>
          <p>
            <HomeIcon /> / Customers / Customers
          </p>
        </header>

        <div className="page_card_body">
          <div className="filters">
            <div className="custom_add_customer">
              <div className="customer_form_fields">
                
                <div className="search_field">
                  <span className="search-icon">
                    <Searchicon />
                  </span>
                  <input
                    type="text"
                    placeholder="Search by name..."
                    className="search-input"
                    value={searchName}
                    onChange={(e) => handleSearch("name", e.target.value)}
                  />
                </div>
                <div className="search_field">
                  <span className="search-icon">
                    <Searchicon />
                  </span>
                  <input
                    type="text"
                    placeholder="Search by mobile..."
                    className="search-input"
                    value={searchMobile}
                    onChange={(e) => handleSearch("mobile", e.target.value)}
                  />
                </div>
              </div>
              <div className="button_outer">
                <Link to="/add-customer">
                  <button className="add-btn btn">Add Customer</button>
                </Link>
              </div>
            </div>

            <div className="export-section">

                <select
    className="dropdown"
    value={customerType}
    onChange={(e) => {
      setCustomerType(e.target.value);
    }}
  >
    <option value="">All Types</option>
    <option value="Business">Business</option>
    <option value="Special Occasion">Special Occasion</option>
  </select>


              <span className="export_sectionfieldset_label">EXPORT CSV</span>
              <select
                className="dropdown"
                value={selectedDateType}
                onChange={handleDateTypeChange}
              >
                <option value="all">All</option>
                <option value="order_date" >Order Date</option>
                <option value="wedding_date">Wedding Date</option>
                <option value="delivery_date">Delivery Date</option>
              </select>

              <ReactDatePicker
                className="date-picker"
                selected={oneMonthBefore ? new Date(oneMonthBefore) : null}
                onChange={(date) => {
                  if (date) {
                    setOneMonthBefore(date.toLocaleDateString("en-CA"));
                  }
                }}
                dateFormat="dd/MM/yyyy"
                locale="en-GB"
                placeholderText="Start Date"
              />

              <ReactDatePicker
                className="date-picker"
                selected={currentDate ? new Date(currentDate) : null}
                onChange={(date) => {
                  if (date) {
                    setCurrentDate(date.toLocaleDateString("en-CA"));
                  }
                }}
                dateFormat="dd/MM/yyyy"
                locale="en-GB"
                placeholderText="End Date"
              />

              <div className="export_btn_with_loader">
                <button className="export-btn" onClick={handleExportCSV}>
                  Export to CSV
                </button>
                {isLoading && (
                  <div className="spinner">
                    <div className="rect1"></div>
                    <div className="rect2"></div>
                    <div className="rect3"></div>
                    <div className="rect4"></div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="customer-table-container">
            {loading && <p>Loading customers...</p>}
            {error && <p className="error">{error}</p>}
            {!loading && !error && (
              <div className="table_outer_for_scroll">
                <table className="customer-table common_table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Mobile</th>
                      <th>Email</th>
                    </tr>
                  </thead>
                  <tbody>
                    {customers.length > 0 ? (
                      customers.map((customer, index) => (
                        <tr
                          key={index}
                          className="clickable-row"
                          onClick={() => handleRowClick(customer._id)}
                          style={{ cursor: "pointer" }}
                        >
                          <td>{customer.customer_name}</td>
                          <td>{customer.mobile}</td>
                          <td>{customer.email}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3">No customers found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}
      >
        <Pagination
          variant="outlined"
          shape="rounded"
          count={totalPages}
          page={page}
          onChange={(event, value) => setPage(value)}
          color="primary"
        />
      </div>
    </Layout>
  );
};

export default CustomerPage;
